import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailMarionetteLine({data, img}) {
    return (
        <MeasurementResult type="마리오네트 주름" description='"마리오네트 주름"은 얼굴의 입 주변에 형성되는 주름을 가리키는 용어이며, 이 주름은 입을 벌릴 때 형성됩나다. 이러한 주름은 표정의 움직임에 따라 형성되며, 특히 웃음이나 말을 할 때 뚜렷해질 수 있습니다. ' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_narionette_lines_front &&
                        <img src={img.image_mark_narionette_lines_front} />
                        }

                        <div className="caption">화이트 라이트</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="마리오네트 주름"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "경도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중증 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}